/**
 * Filename of the running main bundle, e.g. "main.f4d7d7dd.js".
 *
 * A service worker serves the app from cache, so a rebuilt PWA can keep running
 * old code on a phone long after the desktop has the new files. Sending this
 * with the login makes the desktop's [adj-conn] log state which bundle each
 * device is actually executing, instead of leaving it to be inferred from
 * behaviour - which is exactly how several wrong conclusions got drawn.
 */
export function getBundleId(): string {
  try {
    const src = Array.from(document.getElementsByTagName('script'))
      .map((s) => s.src)
      .find((s) => /\/static\/js\/main\.[a-z0-9]+\.js/.test(s));
    return src ? src.split('/').pop() || 'unknown' : 'unknown';
  } catch {
    return 'unknown';
  }
}
